module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00141.ac7c75b6.jpg";